import React from 'react'

import PropTypes from 'prop-types'

import illustrations from '../../../svg/illustrations/illustration-map'
import * as S from './styled'

const Illustration = ({
  className,
  name,
  width,
  posiTop,
  posiBottom,
  posiLeft,
  posiRight,
  absolute,
  zindex,
  marginTop,
  marginBottom,
  ...props
}) => {
  const Illustration = illustrations[name] || illustrations[0]
  return (
    <S.IllustrationWrapper
      className={`${className} illustration-wrapper`}
      name={name}
      posiTop={posiTop}
      posiBottom={posiBottom}
      posiLeft={posiLeft}
      posiRight={posiRight}
      absolute={absolute}
      zindex={zindex}
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      <Illustration width={width} style={{ height: '100%' }} {...props} />
    </S.IllustrationWrapper>
  )
}

Illustration.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  width: PropTypes.string,
  posiTop: PropTypes.number,
  posiBottom: PropTypes.number,
  posiLeft: PropTypes.number,
  posiRight: PropTypes.number,
  absolute: PropTypes.string,
  zindex: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number
}

export default Illustration
